import { useEffect, useState } from "react";

/**
 * Height (px) of the app header marked with `[data-app-header]`, kept in sync with a ResizeObserver.
 * Use it as the `top` of any element that should stick just below the header while the page scrolls.
 */
export function useStickyOffset(fallback = 56) {
  const [top, setTop] = useState(fallback);
  useEffect(() => {
    const el = document.querySelector("[data-app-header]");
    if (!el) return undefined;
    const measure = () => setTop(Math.round(el.getBoundingClientRect().height));
    measure();
    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", measure);
      return () => window.removeEventListener("resize", measure);
    }
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return top;
}
